// Import package components
import { useState, useContext, useCallback, useEffect } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";
import moment from "moment";
import { CSVLink } from "react-csv";

import RecordsPerPage from "../../common/RecordsPerPage";
import Pagination from "../../common/Pagination";
import { AppContexts } from "../../../providers";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";

const columns = [
  { label: "ITEM NAME", key: "item_label" },
  { label: "QUANTITY SOLD", key: "total_quantity" },
  { label: "TOTAL INCOME", key: "total_income" },
];

const OrdersIncomeByItem = () => {
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const { incomeByItem = {}, startDate, endDate, getIncomeByItem, active } = useContext(AppContexts.ReportsContext);
  const { total = 0, paginated = [] } = incomeByItem;
  const path = usePath();

  useEffect(() => {
    if (path !== active) setPage(0);
  }, [path]);

  useEffect(() => {
    if (active === "orders-income-by-item") getFn(startDate, endDate);
  }, [page, filter, recordsPerPage]);

  const getFn = useCallback(
    (startDate, endDate) => {
      if (!startDate || !endDate) {
        return;
      } else {
        getIncomeByItem(
          startDate,
          endDate,
          page,
          recordsPerPage
        );
      }
    },
    [page, recordsPerPage]
  );

  const handlePageChange = useCallback((page) => setPage(page), []);
  const handleFilterChange = useCallback((filter) => setFilter(filter), []);

  return (
    <li className="reports-tab-content">
      <h2>Income By Item</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel
          onFilterChange={handleFilterChange}
          onSubmit={getFn}
        />
        <CSVLink
          data={paginated || []}
          headers={columns}
          filename={`income-by-item-${moment().format("YYYYMMDD-HHmmss")}.csv`}
          className="download"
        >
          <img src="/images/download.svg" uk-tooltip="Download CSV" />
        </CSVLink>
        <div className="secondary">{(Number(total) || 0).toLocaleString()} Items</div>
        <div className="uk-overflow-auto">
          <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
            <thead>
              <tr>
                {columns.map(col => <th key={col.key}>{col.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {paginated?.length ? (
                paginated.map((item, index) => (
                  <tr key={index}>
                    <td>{item.item_label}</td>
                    <td>{item.total_quantity}</td>
                    <td>{item.total_income}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="no-results">
                    No results for this date range
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default OrdersIncomeByItem;
